import React from 'react'
import { Vertical, Texto } from '@gravitate-js/excalibrr'
import classNames from 'classnames'

export const SortableColumn = ({
  title,
  className = 'pr-4 sortable py-3',
  value,
  align = 'right',
  changeSort,
  activeSort,
  sortDirection,
  flex = 1,
}) => {
  const isAscended = activeSort === value && sortDirection === 'asc'
  const isDescended = activeSort === value && sortDirection === 'desc'
  return (
    <Vertical
      onClick={() => changeSort(value)}
      className={classNames('sortable', className, { asc: isAscended }, { desc: isDescended })}
      flex={flex}
      style={{ cursor: 'pointer' }}
    >
      <Texto
        weight='bold'
        category='label'
        appearance='medium'
        align={align}
        style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {title}
      </Texto>
    </Vertical>
  )
}
